import React from 'react'
import { useTranslation } from 'react-i18next'

import authBrandImages from 'assets/images/authentication-page-background.png'
import authBrandImages2x from 'assets/images/authentication-page-background@2x.png'
import { ReactComponent as IconFixTabLogo } from 'assets/svg/logo-fixtab-white.svg'

interface AuthLayoutProps {
  children: React.ReactNode
}

function AuthLayout(props: AuthLayoutProps): JSX.Element {
  const { children } = props
  const { t } = useTranslation('login')

  return (
    <div className='lo-auth'>
      <div className='lo-auth__brand'>
        <h1 className='lo-auth__text'>{t('hero.title')}</h1>
        <picture>
          <source media='(min-width: 1367px)' srcSet={authBrandImages2x} />
          <img
            src={authBrandImages}
            alt='auth brand'
            className='lo-auth__photo'
          />
        </picture>
        <div className='lo-auth__logo'>
          <IconFixTabLogo />
        </div>
        <h5 className='lo-auth__power-by'>{t('poweredBy')}</h5>
      </div>
      <div className='lo-auth__container'>{children}</div>
    </div>
  )
}

export default AuthLayout
